'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var WeekContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  padding: 10px 0;\n  align-items: center;\n  justify-content: space-around;\n  background: ", ";\n"], ["\n  display: flex;\n  padding: 10px 0;\n  align-items: center;\n  justify-content: space-around;\n  background: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
});
var StyledWrapper = styled__default.section(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var DayContainer = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex: none;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 50px;\n  flex-basis: 13%;\n  border-radius: 6px;\n  background: ", ";\n  color: ", ";\n  cursor: pointer;\n"], ["\n  display: flex;\n  flex: none;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 50px;\n  flex-basis: 13%;\n  border-radius: 6px;\n  background: ", ";\n  color: ", ";\n  cursor: pointer;\n"])), function (_a) {
    var selected = _a.selected, theme = _a.theme;
    return (selected ? theme.colors.universal.white : theme.colors.primary);
}, function (_a) {
    var selected = _a.selected, theme = _a.theme;
    return (selected ? theme.colors.primary : theme.colors.universal.white);
});
var DateText = styled__default.span(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  font: 700 18px/22px ", ";\n"], ["\n  font: 700 18px/22px ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var WeekdayText = styled__default.span(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  font: 400 14px/17px ", ";\n"], ["\n  font: 400 14px/17px ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

var WeekDateView = function (_a) {
    var dates = _a.dates, onClick = _a.onClick, _b = _a.locale, locale = _b === void 0 ? undefined : _b, selectedDate = _a.selectedDate, className = _a.className, dataCy = _a.dataCy, dataTestId = _a.dataTestId, timeZone = _a.timeZone;
    var handleOnKeyDown = React.useCallback(function (e, date) {
        e.stopPropagation();
        if ((e.key === 'Enter' || e.key === ' ') && onClick) {
            onClick(date);
        }
    }, [onClick]);
    var renderItem = function (weekDates) { return weekDates.map(function (date) {
        var dateOfMonth = new Date(date).toLocaleString(locale, { day: 'numeric', timeZone: timeZone });
        var nameOfDay = new Date(date).toLocaleString(locale, { weekday: 'short', timeZone: timeZone });
        var isSelected = date.toDateString() === (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.toDateString());
        return (React__default.createElement(DayContainer, { key: date.toLocaleString(), className: "date-container " + (isSelected ? 'selected-date' : ''), 
            // eslint-disable-next-line react/jsx-no-bind
            onClick: onClick ? function () { return onClick(date); } : undefined, 
            // eslint-disable-next-line react/jsx-no-bind
            onKeyDown: function (e) { return handleOnKeyDown(e, date); }, role: "button", selected: isSelected, tabIndex: 0 },
            React__default.createElement(WeekdayText, null, nameOfDay),
            React__default.createElement(DateText, null, dateOfMonth)));
    }); };
    return (React__default.createElement(StyledWrapper, { className: className, "data-cy": dataCy, "data-testid": dataTestId },
        React__default.createElement(WeekContainer, { className: "week-date-container" }, renderItem(dates))));
};

exports.WeekDateView = WeekDateView;
